// src/components/Header.jsx

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const getFinancialYear = () => {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  return month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
};

const Header = ({ title, onMenuToggle }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const { handleLogout } = useAuth();

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="page-header">
      {/* Left: hamburger */}
      <button
        className="mobile-menu-btn"
        onClick={onMenuToggle}
        aria-label="Open menu"
      >
        &#9776;
      </button>

      {/* Middle content */}
      <div className="header-content">
        <h1 className="page-title">{title}</h1>
        <div className="header-info">
          <span>
            {currentTime.toLocaleDateString('en-IN', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
          <span className="info-divider">|</span>
          <span>{currentTime.toLocaleTimeString('en-IN')}</span>
          <span className="info-divider">|</span>
          <span className="fin-year">Financial Year: {getFinancialYear()}</span>
        </div>
      </div>

      {/* Right: logout button */}
      <button onClick={handleLogout} className="header-logout-btn" title="Logout">
        <svg
          className="logout-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
        <span className="logout-text">Logout</span>
      </button>
    </header>
  );
};

export default Header;
